import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "add-large",
  "use": "add-large-usage",
  "viewBox": "0 0 40 40",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 40 40\" id=\"add-large\"><title>add-large</title><g id=\"add-large_uplopad\"><path d=\"M32,2a6.0068,6.0068,0,0,1,6,6V32a6.0068,6.0068,0,0,1-6,6H8a6.0068,6.0068,0,0,1-6-6V8A6.0068,6.0068,0,0,1,8,2H32m0-2H8A8.0235,8.0235,0,0,0,0,8V32a8.0235,8.0235,0,0,0,8,8H32a8.0235,8.0235,0,0,0,8-8V8a8.0235,8.0235,0,0,0-8-8Z\" /><path d=\"M30,19H21V10a1,1,0,0,0-2,0v9H10a1,1,0,0,0,0,2h9v9a1,1,0,0,0,2,0V21h9a1,1,0,0,0,0-2Z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/add-large.svg
// module id = 5bAM
// module chunks = 4